import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { InlineDropdown as InlineDropdown$1 } from '@tesla/design-system-react';
import { useField } from 'informed';

var _excluded = ["label", "feedback", "helper", "caption", "tooltip"],
  _excluded2 = ["id", "disabled", "readonly", "options"];
// import { FeedBack } from './Feedback.js';

var InlineDropdown = function InlineDropdown(props) {
  var _useField = useField(_objectSpread2({}, props)),
    fieldState = _useField.fieldState,
    fieldApi = _useField.fieldApi,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  userProps.label;
    var feedback = userProps.feedback,
    helper = userProps.helper;
    userProps.caption;
    userProps.tooltip;
    var inputProps = _objectWithoutProperties(userProps, _excluded);
  var id = inputProps.id,
    disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    options = inputProps.options,
    restInputProps = _objectWithoutProperties(inputProps, _excluded2);
  var showError = fieldState.showError;
    fieldState.error;
    var value = fieldState.value;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched,
    setFocused = fieldApi.setFocused;
  return render(
  /*#__PURE__*/
  // <FormItem
  //   error={showError}
  //   variant="text"
  //   disabled={disabled}
  //   readOnly={readonly}>
  React.createElement(InlineDropdown$1, _extends({}, restInputProps, {
    id: id,
    disabled: disabled,
    onOptionSelect: function onOptionSelect(_ref) {
      var v = _ref.value;
      setValue(v, {});
    },
    options: options,
    selected: value,
    onBlur: function onBlur(e) {
      setTouched(true, e);
    },
    onFocus: function onFocus(e) {
      setFocused(true, e);
    },
    readOnly: readonly,
    inputRef: ref,
    "aria-invalid": showError,
    "aria-describedby": showError || feedback || helper ? "".concat(id, "-feedback") : undefined
  }))
  //   <FeedBack
  //     feedback={feedback}
  //     helper={helper}
  //     error={error}
  //     showError={showError}
  //     id={`${id}-feedback`}
  //   />
  // </FormItem>
  );
};

export { InlineDropdown };
